const Home = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Home')
const Settings = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Settings')
const Account = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Account')
const Profile = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Profile')
const Sessions = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Sessions')

export default [
  {
    path: '',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Início'
    }
  },
  {
    path: 'settings',
    name: 'Settings',
    component: Settings,
    meta: {
      title: 'Configurações'
    }
  },
  {
    path: 'account',
    name: 'Account',
    component: Account,
    meta: {
      title: 'Conta'
    }
  },
  {
    path: 'profile',
    name: 'Profile',
    component: Profile,
    meta: {
      title: 'Perfil'
    }
  },
  {
    path: 'sessions',
    name: 'Sessions',
    component: Sessions,
    meta: {
      title: 'Sessões'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/common.js